import React, { useState, useEffect } from "react";

const STORAGE_KEY = "raf-textsize";

const TEXT_SIZES = [
  { id: "small",  label: "A", title: "Smaller text",         scale: 1.0 },
  { id: "medium", label: "A", title: "Medium (recommended)", scale: 1.15 },
  { id: "large",  label: "A", title: "Larger text",          scale: 1.3 },
  { id: "xlarge", label: "A", title: "Largest text",         scale: 1.5 },
];

function readInitial() {
  try {
    return localStorage.getItem(STORAGE_KEY) || "medium";
  } catch (e) {
    return "medium";
  }
}

function TextSizeControl() {
  const [size, setSize] = useState(readInitial);

  useEffect(() => {
    const found = TEXT_SIZES.find((s) => s.id === size) || TEXT_SIZES[1];
    document.documentElement.style.setProperty("--text-scale", String(found.scale));
    document.documentElement.setAttribute("data-textsize", size);
    try {
      localStorage.setItem(STORAGE_KEY, size);
    } catch (e) {
      // localStorage unavailable (private mode, etc.) — non-fatal
    }
  }, [size]);

  return (
    <div className="text-size" role="group" aria-label="Adjust text size">
      <span className="text-size__label" aria-hidden="true">Text size</span>
      {TEXT_SIZES.map((s, i) => (
        <button
          key={s.id}
          type="button"
          className={"text-size__btn" + (size === s.id ? " is-active" : "")}
          aria-pressed={size === s.id}
          aria-label={s.title}
          title={s.title}
          onClick={() => setSize(s.id)}
          style={{ fontSize: `${0.78 + i * 0.16}rem` }}
        >
          {s.label}
        </button>
      ))}
    </div>
  );
}

export default TextSizeControl;
